// extracted by mini-css-extract-plugin
module.exports = {"imageLoaderContainer":"EditProfile_imageLoaderContainer__1yD3Z","svg":"EditProfile_svg__3BXhV","pulse":"EditProfile_pulse__18Kiy","svg1":"EditProfile_svg1__3Ijah"};